// Tracking
import { ampli } from "ampli";

export function initBeacon() {
  const BEACON_KEY = "38fb96dc-9187-43f9-bc1c-a2efcd86f33e";
  window.Beacon("init", BEACON_KEY);

  // Docs: https://developer.helpscout.com/beacon-2/web/javascript-api/#usage
  window.Beacon("on", "open", () => ampli.beaconClicked());
  window.Beacon("on", "close", () => ampli.beaconClosed());
  window.Beacon("on", "article-viewed", ({ id }) => ampli.beaconArticleViewed({ article_id: id }));
  window.Beacon("on", "email-sent", () => ampli.beaconEmailSent());
  window.Beacon("on", "search", ({ query }) => ampli.beaconSearched({ search_content: query }));
}
